<template>
  <div class="my_form">
    <el-dialog
      title="详细信息"
      :visible.sync="visible"
      width="1000px"
      top='5vh'
      :before-close="onClose"
    >
      <el-form :model="form" ref="form" inline>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位员工:" prop="staffName">
              <el-select v-model="form.staff_name" filterable>
                <el-option v-for="item in peopleList" :key="item.userId" :label="item.showName" :value="item.userId * 1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证照类型:" prop="licenseType">
              <el-select v-model="form.license_type">
                <el-option v-for="(item,key) in licenseType" :key="key" :label="item" :value="key" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证照编号:" prop="license_no">
              <el-input v-model="form.license_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证照名称:" prop="license_name">
              <el-input v-model="form.license_name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="取证日期:" prop="get_license_date">
              <el-date-picker v-model="form.get_license_date" type="date"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生效日期:" prop="effective_date">
              <el-date-picker v-model="form.effective_date" type="date"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态:" prop="status">
              <el-select v-model="form.status" filterable>
                <el-option v-for="(item,key) in licenseStatus" :key="key" :label="item" :value="key" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期限限制:" prop="expiration_period">
              <el-radio v-model="form.expiration_period" :label="true">是</el-radio>
              <el-radio v-model="form.expiration_period" :label="false">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.expiration_period">
            <el-form-item label="到期日期:" prop="expire_date">
              <el-date-picker v-model="form.expire_date" type="date"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.expiration_period">
            <el-form-item label="到期提醒时间:" prop="remind_time">
              <el-date-picker v-model="form.remind_time" type="datetime"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="定时提醒人员:" prop="remind_user">
                <el-select v-model="form.remind_user" multiple filterable>
                  <el-option
                    v-for="item in peopleList"
                    :key="item.userId"
                    :label="item.showName"
                    :value="item.userId*1">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门:" prop="create_dept_id">
              <el-select v-model="form.create_dept_id" filterable>
                <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发证部门:" prop="notified_body">
              <el-input v-model="form.notified_body"  type="textarea" :rows="3" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注:" prop="remark">
              <el-input v-model="form.remark"  type="textarea" :rows="3" />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="record.attachment_name && record.attachment_name.length">
            <el-form-item label="附件:" prop="file">
              <div v-for="item in JSON.parse(record.attachment_name)" :key="item.filename">
                <a href="javascript:;" @click="handleDownload(item.filename)">{{item.name}}</a>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { licenseType, licenseStatus} from '@/utils/data'
import { LicenseManagement } from '@/api/Licence'
import projectConfig from '@/core/config'

export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  // mixins: [globalMixin],
  data () {
    return {
      form: {
        staff_name: '',
        license_type: '',
        license_no: '',
        license_name: '',
        expiration_period: false,
        expire_date: '',
        remind_time: '',
        remind_user: [],
        get_license_date: '',
        effective_date: '',
        create_dept_id: '',
        notified_body: '',
        remark: '',
        attachment_name: []
      },
      peopleList: [], // 用户列表
      deptList: [], // 部门列表
      licenseType,
      licenseStatus,
      token: localStorage.getItem('token')
    };
  },
  watch: {
    visible (val) {
      if (val && this.record.create_user_id) {
        this.form = JSON.parse(JSON.stringify(this.record))
        this.form.staff_name = this.form.staff_name * 1
        if (this.form.remind_user && this.form.remind_user !== '0') {
          this.form.remind_user = this.form.remind_user.split(',').map(item => item * 1)
        }
        //  else {
        //   this.form.remind_user = []
        // } 
      } else {
        this.form = {
          staff_name: '',
          license_type: '',
          license_no: '',
          license_name: '',
          expiration_period: false,
          expire_date: '',
          remind_time: '',
          remind_user: [],
          get_license_date: '',
          effective_date: '',
          create_dept_id: '',
          notified_body: '',
          remark: '',
          attachment_name: ''
        }
      }
    }
  },
  created () {
    this.getDeptAndPeople()
  },
  methods: {
    getDeptAndPeople () {
      LicenseManagement.getDeptList(this, {}).then(res => {
        this.deptList = res.data.dataList
      })
      LicenseManagement.getPeopleList(this, {}).then(res => {
        this.peopleList = res.data.dataList
      })
    },
    onClose () {
      this.$emit('update:visible', false);
    },
    handleDownload (filename) {
      const url = projectConfig.baseUrl + 'admin/online/onlineOperation/downloadDatasource/oaFormStaffLicensertext?datasourceId=1631157465292738560&fieldName=attachment_name&asImage=false&dataId=' + this.record.license_id + '&filename=' + filename + '&Authorization=' + this.token + '&MenuId=1631159779164426240'
      this.downloadFile(url, filename)
    }
  }
};
</script>

<style lang="scss" scoped>
// :deep(.el-dialog__body) {
//   min-height: 834px;
// }
</style>
